import { render, staticRenderFns } from "./deporder.vue?vue&type=template&id=2d23fa60&scoped=true&"
import script from "./deporder.vue?vue&type=script&lang=js&"
export * from "./deporder.vue?vue&type=script&lang=js&"
import style0 from "./deporder.vue?vue&type=style&index=0&id=2d23fa60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23fa60",
  null
  
)

export default component.exports